import React from "react";
import { Box, Button, CssBaseline, Typography } from "@mui/material";
import { styled } from "@mui/material/styles";
import BusinessIcon from "@mui/icons-material/Business";
import PeopleAltIcon from "@mui/icons-material/PeopleAlt";
import { Link } from "react-router-dom";
import MainHeader from "../../components/MainHeader";
import Rodape from "../../components/Rodape";
import HeaderSecti from "../../components/HeaderSecti";

// Tela de escolha do tipo de cadastro (/select-cadastro), refeita em 04/09/2026
// na MESMA casca do SignIn (artboard "Login Oxetech", opcao 1b "Cartao
// central"): fundo creme, dois circulos decorativos e um unico cartao branco
// centralizado. Antes era a tela antiga -- Montserrat, cartao de borda laranja e
// tres pilulas de raio 30px, uma laranja, uma amarela e uma azul.
//
// Os valores abaixo sao os mesmos do SignIn e do SignUpAluno, arquivo a arquivo:
// as tres telas de entrada tem de ser a mesma peca.
const COR = {
  fundo: "#FFF9EF",
  circuloA: "#FCEFD6",
  circuloB: "#FBE7D3",
  cartaoBorda: "#F0E6D6",
  titulo: "#1F1E1C",
  textoSuave: "#6B655D",
  rotulo: "#3B3833",
  campoBorda: "#E6DDCE",
  laranja: "#D2551D",
  laranjaHover: "#B8460F",
};

const FONTE = "'Poppins', system-ui, sans-serif";

const LinkTexto = styled(Link)({
  fontFamily: FONTE,
  color: COR.laranja,
  textDecoration: "none",
  "&:hover": { color: "#A83D0C", textDecoration: "underline" },
});

// Botao de 56px/raio 11px, a mesma medida do ENTRAR do login.
const baseBotao = {
  height: 56,
  borderRadius: "11px",
  fontFamily: FONTE,
  fontSize: 16,
  fontWeight: 600,
  letterSpacing: ".06em",
  textTransform: "uppercase",
  width: "100%",
  "&:active": { transform: "translateY(1px)" },
};

export default function SelectSignUp() {
  return (
    <>
      <HeaderSecti />
      <CssBaseline />
      <MainHeader />

      <Box
        sx={{
          position: "relative",
          overflow: "hidden",
          background: COR.fundo,
          minHeight: { xs: "auto", md: "72vh" },
          width: "100%",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          py: { xs: 5, md: 8 },
          px: 2,
        }}
      >
        {/* Circulos decorativos, nas mesmas posicoes do login. aria-hidden e
            pointerEvents none para nao entrarem na navegacao por leitor de tela
            nem capturarem clique. */}
        <Box
          aria-hidden
          sx={{
            position: "absolute",
            left: -120,
            top: 60,
            width: 300,
            height: 300,
            borderRadius: "50%",
            background: COR.circuloA,
            pointerEvents: "none",
            display: { xs: "none", md: "block" },
          }}
        />
        <Box
          aria-hidden
          sx={{
            position: "absolute",
            right: -90,
            bottom: -90,
            width: 340,
            height: 340,
            borderRadius: "50%",
            background: COR.circuloB,
            pointerEvents: "none",
            display: { xs: "none", md: "block" },
          }}
        />

        <Box
          sx={{
            position: "relative",
            width: "100%",
            maxWidth: 520,
            background: "#fff",
            borderRadius: "20px",
            border: `1px solid ${COR.cartaoBorda}`,
            boxShadow: "0 22px 50px rgba(70, 40, 10, .13)",
            p: { xs: "32px 24px", sm: "44px 48px" },
            display: "flex",
            flexDirection: "column",
            gap: "24px",
          }}
        >
          <Box sx={{ display: "flex", flexDirection: "column", gap: "6px", textAlign: "center" }}>
            <Typography
              component="h1"
              sx={{
                fontFamily: FONTE,
                fontSize: { xs: 26, sm: 30 },
                fontWeight: 700,
                letterSpacing: "-.01em",
                color: COR.titulo,
              }}
            >
              Cadastre-se
            </Typography>
            {/* Substitui o "Acesse nossa Plataforma" que ficava solto no pe do
                cartao antigo: ali era um rotulo sem funcao; aqui e o subtitulo
                que diz o que a tela pede, como no login. */}
            <Typography sx={{ fontFamily: FONTE, fontSize: 15, color: COR.textoSuave }}>
              Escolha como você quer se cadastrar
            </Typography>
          </Box>

          <Box sx={{ display: "flex", flexDirection: "column", gap: "14px" }}>
            {/* Pessoa fisica e a acao PRIMARIA (laranja cheio, igual ao ENTRAR);
                pessoa juridica e a secundaria (contorno). Antes as duas eram
                pilulas cheias em laranjas diferentes, sem hierarquia. */}
            <Button
              component={Link}
              to="/cadastro"
              startIcon={<PeopleAltIcon />}
              sx={{
                ...baseBotao,
                background: COR.laranja,
                color: "#fff",
                boxShadow: "0 10px 22px rgba(210, 85, 29, .26)",
                "&:hover": { background: COR.laranjaHover },
              }}
            >
              Pessoa física
            </Button>

            <Button
              component={Link}
              to="/empresa-cadastro"
              startIcon={<BusinessIcon />}
              sx={{
                ...baseBotao,
                background: "#fff",
                color: COR.rotulo,
                border: `1.5px solid ${COR.campoBorda}`,
                "&:hover": { background: COR.fundo, border: `1.5px solid ${COR.campoBorda}` },
              }}
            >
              Pessoa jurídica
            </Button>
          </Box>

          {/* "Ja tenho cadastro" era a terceira pilula, azul e do mesmo tamanho
              das outras duas -- competia com as opcoes de cadastro, que sao o
              assunto da tela. Virou link de texto no pe do cartao, no mesmo
              lugar e formato que o login usa para o caminho inverso. */}
          <Box sx={{ display: "flex", flexDirection: "column", gap: "12px" }}>
            <Typography
              sx={{
                textAlign: "center",
                fontFamily: FONTE,
                fontSize: 15,
                color: COR.textoSuave,
              }}
            >
              Já tem cadastro?{" "}
              <LinkTexto to="/login" style={{ fontWeight: 600 }}>
                Entrar
              </LinkTexto>
            </Typography>

            <Typography
              sx={{
                textAlign: "center",
                fontFamily: FONTE,
                fontSize: 14,
                color: COR.textoSuave,
              }}
            >
              <LinkTexto to="/ajuda">Precisa de ajuda?</LinkTexto>
            </Typography>
          </Box>
        </Box>
      </Box>

      <Rodape />
    </>
  );
}
